export const workspaceNavigation = [
  { path: "/", label: "沟通", title: "沟通与协作", icon: "chat" },
  { path: "/projects", label: "项目", title: "项目工作台", icon: "projects" },
  { path: "/memory", label: "Memory", title: "个人与团队记忆", icon: "memory" },
  { path: "/documents", label: "文档", title: "文档与文件", icon: "file" },
  { path: "/me", label: "更多", title: "更多与我的", icon: "more" },
] as const;

export function activeWorkspace(path: string, savedChannelId?: string) {
  if (
    path === "/projects" ||
    path.startsWith("/projects/") ||
    path.startsWith("/plugins/")
  )
    return "/projects";
  if (
    path === "/notes" ||
    path === "/memory" ||
    path.startsWith("/memory/") ||
    (savedChannelId &&
      (path === `/channel/${savedChannelId}` ||
        path.startsWith(`/channel/${savedChannelId}/`)))
  )
    return "/memory";
  if (path === "/documents") return "/documents";
  if (path === "/me" || path === "/settings") return "/me";
  return "/";
}
